module.exports = __webpack_public_path__ + "img/img_Colleges17.0da0f213.jpg";